module.exports = __webpack_public_path__ + "static/scrabblista-desktop-1.fb07c8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/project/scrabblista/img/scrabblista-desktop-1.png
// module id = 622
// module chunks = 230197332751855